exports.onRouteUpdate = ({ location }) => {
  document.cookie = `ane_redirect=${location.href};path=/;max-age=900000;domain=.${location.hostname}`;
};

exports.onClientEntry = () => {
  document.cookie = `ane_redirect=${window.location.href};path=/;max-age=900000;domain=.${window.location.hostname}`;
};
